var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrevArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flecha 1 banner"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    filter: "url(#filter0_d_1194_197)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42 22.5C42 11.7309 33.2691 3 22.5 3C11.7309 3 3 11.7309 3 22.5C3 33.2691 11.7309 42 22.5 42C33.2691 42 42 33.2691 42 22.5ZM17.8716 22.5L25.8103 30.4397C26.0797 30.7233 26.2277 31.1009 26.2227 31.492C26.2177 31.8832 26.0601 32.2569 25.7835 32.5335C25.5069 32.8101 25.1332 32.9677 24.742 32.9727C24.3509 32.9777 23.9733 32.8297 23.6897 32.5603L14.6897 23.5603C14.4086 23.279 14.2507 22.8977 14.2507 22.5C14.2507 22.1023 14.4086 21.721 14.6897 21.4397L23.6897 12.4397C23.9733 12.1703 24.3509 12.0223 24.742 12.0273C25.1332 12.0323 25.5069 12.1899 25.7835 12.4665C26.0601 12.7431 26.2177 13.1168 26.2227 13.508C26.2277 13.8991 26.0797 14.2767 25.8103 14.5603L17.8716 22.5Z",
    fill: "white",
    fillOpacity: 0.8,
    shapeRendering: "crispEdges"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1194_197",
    x: 0,
    y: 0,
    width: 49,
    height: 49,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.53 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1194_197"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1194_197",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevArrow);
export default __webpack_public_path__ + "static/media/prev-arrow.e585f60a1008de91488c6f9eddbd6f88.svg";
export { ForwardRef as ReactComponent };